import { useUiLangStore, type UiLang } from "../stores/uiLang";

// Run E2 J2: small EN/ES switch for the site header. It sets the shared UI
// language (stores/uiLang.ts) used by the header, footer, menus and buttons.
const OPTIONS: { value: UiLang; label: string; title: string }[] = [
  { value: "en", label: "EN", title: "English" },
  { value: "es", label: "ES", title: "Español" },
];

export function LangSwitch({ className = "" }: { className?: string }) {
  const lang = useUiLangStore((s) => s.lang);
  const setLang = useUiLangStore((s) => s.setLang);
  return (
    <div
      className={`inline-flex rounded-md border border-gray-300 overflow-hidden ${className}`}
      role="group"
      aria-label={lang === "es" ? "Idioma" : "Language"}
    >
      {OPTIONS.map((o) => {
        const active = o.value === lang;
        return (
          <button
            key={o.value}
            type="button"
            lang={o.value}
            title={o.title}
            aria-pressed={active}
            onClick={() => setLang(o.value)}
            className={`px-2 py-1 text-xs font-semibold ${
              active ? "bg-gray-900 text-white" : "bg-white text-gray-700 hover:bg-gray-50"
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
